import React, { useCallback } from 'react';
import { Button } from 'reactstrap';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from 'js/components';
import { useEditorContext } from 'js/ydoc/docs/capabilities-assessment/EditorContext';
import styles from '../CapabilitiesAssessmentEditor.module.scss';

function PageActions({ page }) {
  const { deletePage } = useEditorContext();

  const handleDeletePage = useCallback(() => {
    deletePage(page.guid);
  }, [deletePage, page.guid]);

  return (
    <div className={styles['page-actions']}>
      <Button
        className="btn-action-alt"
        color="primary"
        onClick={handleDeletePage}
      >
        <Icon icon={faTrashAlt} className="icon icon-left" />
        Delete
      </Button>
    </div>
  );
}

export default PageActions;
